import { enableProdMode } from '@angular/core';
import { environment } from '@environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) enableProdMode();

// ag-grid registration lives in @core/ag-grid.setup, imported by GridComponent and grid.util,
// so ag-grid ships in the lazy chunks that need it instead of in this entry point.

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
